import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export const ActionDialog = ({ title, onClose, children, testid, wide }) => (
  <Dialog open onOpenChange={(o) => !o && onClose()}>
    <DialogContent className={`${wide ? 'max-w-4xl' : 'max-w-xl'} max-h-[90vh] overflow-y-auto`} data-testid={testid}>
      <DialogHeader><DialogTitle className="text-[#1e40af]">{title}</DialogTitle></DialogHeader>
      {children}
    </DialogContent>
  </Dialog>
);

export const Field = ({ label, children }) => (
  <label className="block text-sm">
    <span className="text-gray-600 font-medium">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

export const inputCls = 'w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-[#5bc0de] outline-none';
export const primaryBtn = 'bg-[#1e40af] text-white px-4 py-2 rounded text-sm hover:bg-[#1e3a8a] disabled:opacity-50';

export const Loading = () => <p className="text-sm text-gray-500 py-6 text-center">Loading…</p>;
